import { useEffect, useState } from "react";

// Compare local civil dates, never an ISO/UTC day. Recheck after sleeping or travel.
export const localDateKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
export const localDayOfYear = (date) => Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 86400000);

export const useLocalDate = () => {
  const [day, setDay] = useState(() => ({ date: new Date(), key: localDateKey(new Date()) }));
  useEffect(() => {
    let midnight;
    const refresh = () => {
      const date = new Date();
      const key = localDateKey(date);
      setDay((previous) => previous.key === key ? previous : { date, key });
      clearTimeout(midnight);
      midnight = setTimeout(refresh, new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1) - date + 20);
    };
    refresh();
    const interval = setInterval(refresh, 60000);
    window.addEventListener("focus", refresh);
    window.addEventListener("pageshow", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      clearTimeout(midnight); clearInterval(interval);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("pageshow", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  return day.date;
};